import React, { useEffect, useState } from "react"; // Import useState and useEffect
import { useTranslation } from "react-i18next";
import UK_flag from "../imgs/translations/UK_flag.png";
import NL_flag from "../imgs/translations/NL_flag.png";

const languages = [
  { code: "en", name: "English", img: UK_flag },
  { code: "nl", name: "Nederlands", img: NL_flag },
];

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [currentLangObject, setCurrentLangObject] = useState(null);

  useEffect(() => {
    const currentLangCode =
      i18n.resolvedLanguage?.split("-")[0] ||
      i18n.language?.split("-")[0] ||
      "en";
    const langObject =
      languages.find((lang) => lang.code === currentLangCode) || languages[0]; // Default to first language if not found
    setCurrentLangObject(langObject);

    const handleLanguageChanged = (lng) => {
      const newLangCode = lng.split("-")[0];
      const newLangObject =
        languages.find((lang) => lang.code === newLangCode) || languages[0];
      setCurrentLangObject(newLangObject);
    };
    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, [i18n, i18n.language, i18n.resolvedLanguage]); // Rerun if i18n instance or language changes

  const cycleLanguage = () => {
    if (!currentLangObject) return; // Guard if state isn't set yet

    const currentIndex = languages.findIndex(
      (lang) => lang.code === currentLangObject.code
    );

    const nextIndex = (currentIndex + 1) % languages.length;
    const nextLang = languages[nextIndex];

    i18n.changeLanguage(nextLang.code);
  };

  if (!currentLangObject) {
    return null;
  }

  return (
    <div className="fixed bottom-4 -left-12 transition-all duration-300 hover:left-0 z-50  bg-opacity-70 rounded shadow-lg">
      <button
        onClick={cycleLanguage}
        title={`Switch to ${
          languages[
            (languages.findIndex((l) => l.code === currentLangObject.code) +
              1) %
              languages.length
          ].name
        }`}
        className="
        cursor-pointer 
        transition-transform 
        duration-200 
        hover:scale-110 
        focus:outline-none 
        focus:ring-2 
        focus:ring-offset-1 
        focus:ring-blue-500 
        rounded"
      >
        <img
          className="w-16 rounded-sm" // Fixed width, auto height, slight rounding
          src={currentLangObject.img}
          alt={currentLangObject.name} // Alt text for accessibility
        />
      </button>
    </div>
  );
}

export default LanguageSwitcher;
